// entries that can appear in the comma delimited custom:typeOfWork Cognito attribute, stored lowercase
export const TYPE_OF_WORK = {
	fileMaker: 'fm',
	salesforce: 'sf',
	web: 'web'
}

// matches commas and whitespace, so legacy space delimited values (e.g. "FM Web") parse the same as the comma list
const TYPE_OF_WORK_DELIMITER = /[\s,]+/

// splits the custom:typeOfWork attribute (e.g. "FM, SF, Web" or legacy "FM Web") into lowercase entries
export function parseTypeOfWork(typeOfWork?: string) {
	return (typeOfWork || '')
		.split(TYPE_OF_WORK_DELIMITER)
		.map((entry) => entry.toLowerCase())
		.filter(Boolean)
}

// determines whether the comma delimited typeOfWork attribute includes the given entry
export function hasTypeOfWork(typeOfWork: string | undefined, entry: string) {
	return parseTypeOfWork(typeOfWork).includes(entry.toLowerCase())
}

// Licensing covers Claris FileMaker licenses, so it shows for customers with FileMaker (FM) in their
// type of work, and for anyone who actually holds a license whatever their type of work says, so a
// license is never hidden from the customer who owns it. the sidebar menu and the dashboard card both
// ask here, so they cannot disagree
export function showsLicensing(typeOfWork: string | undefined, hasLicenses: boolean) {
	return hasTypeOfWork(typeOfWork, TYPE_OF_WORK.fileMaker) || hasLicenses
}
